import PropTypes from 'prop-types';

const LinearGradientDivider = (props) => {
    const { width = '64px', height = '64px', topColor, bottomColor } = props;
    return (
        <div
            style={{
                width: width,
                height: height,
                background: `linear-gradient(45deg, ${topColor} 50%, ${bottomColor} 50%)`
            }}
        />
    );
};

LinearGradientDivider.propTypes = {
    width: PropTypes.string,
    height: PropTypes.string,
    topColor: PropTypes.string,
    bottomColor: PropTypes.string
};

export default LinearGradientDivider;
